import React from 'react';

import truck_base from 'image/loading/loading-truck-body1.svg';
import truck_wheel from 'image/loading/loading-truck-wheel.svg';
import truck_body from 'image/loading/loading-truck-body2.svg';
import truck_gas1 from 'image/loading/loading-truck-gas3.svg';
import truck_gas2 from 'image/loading/loading-truck-gas2.svg';
import truck_gas3 from 'image/loading/loading-truck-gas1.svg';

const LoadingList = () => {
  return (
    <div className="wrap-loading LoadingList">
      <div>
        <img src={truck_base} alt="truck base" id="truck-base" className="truck-body" />
        <img src={truck_wheel} alt="truck wheel" id="truck-wheel" className="truck-wheel" />
        <img src={truck_body} alt="truck body" id="truck-body" className="truck-body" />
        <img src={truck_gas1} alt="truck gas" id="truck-gas1" className="truck-gas" />
        <img src={truck_gas2} alt="truck gas" id="truck-gas2" className="truck-gas" />
        <img src={truck_gas3} alt="truck gas" id="truck-gas3" className="truck-gas" />
      </div>
    </div>
  );
}

export default LoadingList;